import {Injectable} from '@angular/core';
import {deserialize, JsonApiParams, JsonApiResponse} from '@tisa-group/cdk';
import {UmpireOttStream} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class OttStreamService {
  constructor(readonly http: TisaUmpireHttpService) {}

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttStream>> {
    return this.http
      .get(`/ott/events/${fetchIdentifier}/stream`, {
        params,
      })
      .pipe(deserialize());
  }

  startBroadcasting(streamId: string): Observable<JsonApiResponse<UmpireOttStream>> {
    return this.http
      .patch(`/ott/streams/${streamId}/start`, {
        data: {
          id: streamId,
          type: 'ott_stream',
          // TODO: remove atributes
          attributes: {use_backup: false},
        },
      })
      .pipe(deserialize());
  }

  pauseBroadcasting(streamId: string): Observable<JsonApiResponse<UmpireOttStream>> {
    return this.http
      .patch(`/ott/streams/${streamId}/pause`, {
        data: {
          id: streamId,
          type: 'ott_stream',
          // TODO: remove atributes
          attributes: {use_backup: false},
        },
      })
      .pipe(deserialize());
  }

  stopBroadcasting(streamId: string): Observable<JsonApiResponse<UmpireOttStream>> {
    return this.http
      .patch(`/ott/streams/${streamId}/stop`, {
        data: {
          id: streamId,
          type: 'ott_stream',
          attributes: {use_backup: false},
        },
      })
      .pipe(deserialize());
  }

  triggerStreamDownload(streamId: string): Observable<void> {
    return this.http.post(`/ott/streams/${streamId}/download`, {});
  }

  fetchStreamData(streamId: string): Observable<JsonApiResponse<UmpireOttStream>> {
    return this.http.get(`/ott/streams/${streamId}`).pipe(deserialize());
  }
}
